import * as React from "react";
const SvgShapes = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.33333 6.66667L8 2L10.6667 6.66667H5.33333Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.66667 11.6667C6.66667 12.9553 5.622 14 4.33333 14C3.04467 14 2 12.9553 2 11.6667C2 10.378 3.04467 9.33333 4.33333 9.33333C5.622 9.33333 6.66667 10.378 6.66667 11.6667Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.33333 9.33333H14V14H9.33333V9.33333Z",
      stroke: "currentColor",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgShapes;
